import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { exchangeDiscordCode } from '@/api/auth';
import { Button } from '@/components/ui/button';

const exchangePromisesByCode = new Map();

export default function OAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('処理中です...');
  const [error, setError] = useState(null);

  useEffect(() => {
    let search = location.search;
    if (!search && typeof window !== 'undefined') {
      const hash = window.location.hash || '';
      const queryIndex = hash.indexOf('?');
      if (queryIndex !== -1) {
        search = hash.substring(queryIndex);
      }
    }

    const queryParams = new URLSearchParams(search);
    const code = queryParams.get('code');
    const errorParam = queryParams.get('error');

    if (errorParam) {
      setStatus('Discord認証中にエラーが発生しました。');
      setError(errorParam);
      return;
    }

    if (!code) {
      setStatus('Discordからの認証コードが見つかりません。');
      setError('code_missing');
      return;
    }

    (async () => {
      try {
        console.log('[OAuthCallback] Starting exchange with code:', code);
        setStatus('ログイン情報を取得しています...');

        let exchangePromise = exchangePromisesByCode.get(code);
        if (!exchangePromise) {
          exchangePromise = exchangeDiscordCode(code);
          exchangePromisesByCode.set(code, exchangePromise);
        }

        const result = await exchangePromise;
        console.log('[OAuthCallback] Exchange successful, result:', result);
        setStatus('ログインに成功しました。リダイレクト中...');
        window.dispatchEvent(new Event('auth:changed'));
        console.log('[OAuthCallback] Dispatching auth:changed event');
        setTimeout(() => {
          console.log('[OAuthCallback] Navigating to /Home');
          navigate('/Home');
        }, 500);
      } catch (err) {
        console.error('[OAuthCallback] Exchange failed:', err);
        setStatus('ログインに失敗しました。');
        setError(err.message || 'unknown_error');
      }
    })();
  }, [location.search, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#faf6f1] via-[#f5ede3] to-[#efe5d8] flex items-center justify-center text-[#2d1810]">
      <div className="max-w-xl w-full p-8 bg-white/90 border border-zinc-200 rounded-2xl shadow-lg text-center">
        <h2 className="text-xl font-bold mb-4">Discord OAuth 認証</h2>
        <p className="mb-3">{status}</p>
        {error && (
          <div className="mb-4 space-y-2 text-sm text-red-600">
            <p>詳細: {String(error)}</p>
            <p>解決しない場合は、運営へお問い合わせください。</p>
          </div>
        )}
        <Button onClick={() => navigate('/')} className="bg-[#3d2817] hover:bg-[#2d1810] text-[#f5ede3]">
          トップに戻る
        </Button>
      </div>
    </div>
  );
}
